/* =========================================================================
 * Kkumi · Wishlist Search bar
 * The live search box above the cards (sections/kkumi-wishlist-grid.liquid,
 * "Search" settings). Types into KkwlBus.search — registered by
 * kkumi-wishlist-grid.js, which filters/ranks the cards in place with the
 * kkumi-wishlist-search.js engine (no reload). Also: "[count] of [total]
 * match" status, clear button, Esc to clear, "/" to focus, optional ?q= sync.
 * Every string and filter word comes from the section's data-* attributes.
 * ========================================================================= */
(function () {
  'use strict';

  var boxes = document.querySelectorAll('[data-kkwl-search]');
  if (!boxes.length || !window.KkwlBus) return;

  function wire(box) {
    var input = box.querySelector('.kkwl-search__field');
    if (!input) return;
    var clearBtn = box.querySelector('[data-kkwl-search-clear]');
    var icon = box.querySelector('.kkwl-search__icon');
    var statusEl = box.querySelector('[data-kkwl-search-status]');
    var ds = box.dataset;
    var statusTpl = ds.kkwlSearchStatusTpl || '[count] of [total] match';
    var syncUrl = ds.kkwlSearchUrl !== 'false';
    var keywords = {
      sale: ds.kkwlKwSale || 'sale, on sale',
      instock: ds.kkwlKwInstock || 'in stock',
      oos: ds.kkwlKwOos || 'out of stock, sold out',
      under: ds.kkwlKwUnder || 'under',
      over: ds.kkwlKwOver || 'over',
      fuzzy: ds.kkwlSearchFuzzy !== 'false'
    };
    var timer;

    function paintInput() {
      var has = input.value.length > 0;
      if (clearBtn) clearBtn.hidden = !has;
      if (icon) icon.hidden = has;
    }
    function writeUrl(q) {
      if (!syncUrl || !window.history || !history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (q.trim()) url.searchParams.set('q', q.trim()); else url.searchParams.delete('q');
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }
    function run(q) {
      clearTimeout(timer);
      writeUrl(q);
      if (window.KkwlBus.search) window.KkwlBus.search(q, keywords);
      else window.KkwlBus.pendingSearch = { query: q, keywords: keywords }; // grid script not run yet — it picks this up
    }

    input.addEventListener('input', function () {
      paintInput();
      clearTimeout(timer);
      var q = input.value;
      timer = setTimeout(function () { run(q); }, 90);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) { e.preventDefault(); input.value = ''; paintInput(); run(''); }
      if (e.key === 'Enter') { e.preventDefault(); run(input.value); }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; paintInput(); run(''); input.focus(); });

    // The grid reports results (and clears from its own "Clear search" button).
    window.KkwlBus.on('search', function (r) {
      if (!r) return;
      if (r.query !== input.value && document.activeElement !== input) { input.value = r.query; paintInput(); }
      if (!r.query) writeUrl('');
      if (statusEl) {
        var msg = r.active ? statusTpl.replace('[count]', r.matches).replace('[total]', r.total) : '';
        if (statusEl.textContent !== msg) statusEl.textContent = msg;
      }
    });

    // "/" jumps to the search (like most storefront search boxes).
    if (ds.kkwlSearchShortcut !== 'false') {
      document.addEventListener('keydown', function (e) {
        if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        if (!input.offsetParent) return; // grid hidden (empty / guest)
        e.preventDefault();
        input.focus();
        input.select();
      });
    }

    // Deep link: ?q= restores a search. If the grid script hasn't registered
    // yet, run() parks it on the bus; cards that arrive later are filtered by
    // the grid as they render.
    var initial = '';
    try { initial = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) {}
    if (initial) { input.value = initial; run(initial); }
    paintInput();
  }


  Array.prototype.forEach.call(boxes, function (box) {
    if (box.dataset.kkBound) return;
    box.dataset.kkBound = '1';
    wire(box);
  });
})();
